import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useMainstreamCountries } from '@/hooks/queries/use-mainstream-countries';
import { useProfileAmlEligibility } from '@/hooks/queries/use-profile-aml';
import { useProfileFcaQuestionnaireEligibility } from '@/hooks/queries/use-profile-fca-questionnaire';
import { useProfileIdentity } from '@/hooks/queries/use-profile-identity';
import { isJurisdictionPermitted } from '@/utils';

type IneligibilityReason = 'JURISDICTION' | 'FCA' | 'AML';

const INELIGIBLE_PATHS = {
  JURISDICTION: (jurisdiction: string) => `/onboarding/personal-information/forbidden-jurisdiction/${jurisdiction}`,
  FCA: '/onboarding/fca-questionnaire/ineligible',
  AML: '/onboarding/aml-questionnaire/ineligible',
} as const satisfies Record<IneligibilityReason, unknown>;

const OnboardingEligibilityGuard = () => {
  const { data: countries } = useMainstreamCountries();
  const { data: identity } = useProfileIdentity();
  const { data: fcaQuestionnaireEligibility } = useProfileFcaQuestionnaireEligibility(identity?.addressOfResidency.country);
  const { data: amlEligibility } = useProfileAmlEligibility();
  const location = useLocation();
  const countryOfResidency = identity?.addressOfResidency.country;

  if (countryOfResidency) {
    if (countries && !isJurisdictionPermitted(countryOfResidency, countries) && location.pathname !== INELIGIBLE_PATHS.JURISDICTION(countryOfResidency)) {
      return <Navigate to={INELIGIBLE_PATHS.JURISDICTION(countryOfResidency)} replace />;
    }

    if (fcaQuestionnaireEligibility === false && location.pathname !== INELIGIBLE_PATHS.FCA) {
      return <Navigate to={INELIGIBLE_PATHS.FCA} replace />;
    }
  }

  if (amlEligibility === false && location.pathname !== INELIGIBLE_PATHS.AML) {
    return <Navigate to={INELIGIBLE_PATHS.AML} replace />;
  }

  return <Outlet />;
};
OnboardingEligibilityGuard.displayName = 'OnboardingEligibilityGuard';

export default OnboardingEligibilityGuard;
